module.exports = __webpack_public_path__ + "static/filters_redesign-c00b65d96e06828e4521122aaeb19e6d.png";